import React from "react";
import { Icon } from "../core/Icon.jsx";

/** Short standalone statement — "sin niños", "compartir fotos", a note from the couple. */
export function NoteCard({ icon, title, body, hashtag, framed = true, tone = "default", style }) {
  const fg = tone === "onDark" ? "var(--fg-on-contrast)" : "var(--fg-primary)";
  const muted = tone === "onDark" ? "color-mix(in srgb, var(--fg-on-contrast) 66%, transparent)" : "var(--fg-secondary)";
  return (
    <article style={{
      display: "grid", justifyItems: "center", gap: "var(--sp-3)", textAlign: "center",
      padding: framed ? "var(--sp-7) var(--sp-5)" : 0,
      border: framed ? "var(--border-hair) solid var(--rule)" : "none",
      ...style,
    }}>
      {icon && <Icon name={icon} size={30} style={{ color: "var(--accent)" }} />}
      {title && (
        <h3 style={{ margin: 0, fontFamily: "var(--font-flourish, var(--font-script))", fontWeight: 400, fontSize: "var(--fs-title)", lineHeight: 1.1, color: "var(--accent)" }}>{title}</h3>
      )}
      {body && <p style={{ margin: 0, maxWidth: 300, fontSize: "var(--fs-body-s)", lineHeight: "var(--lh-loose)", color: muted, textWrap: "pretty" }}>{body}</p>}
      {hashtag && (
        <p style={{ margin: "var(--sp-2) 0 0", fontFamily: "var(--font-caps)", fontSize: "var(--fs-caption)", letterSpacing: "var(--ls-wider)", color: "var(--fg-muted)" }}>{hashtag}</p>
      )}
    </article>
  );
}
